export const accountSetup = {
  payments: {
    planUnavailableTitle: "Niedostępne w Twoim planie",
    planUnavailableMessage:
      "Płatności gości przez Stripe są dostępne wyłącznie w planach Standard i wyższych. Podnieś plan, aby włączyć tę funkcję i pobierać płatności bezpośrednio, bez pośredników.",
  },
  modalConnection: {
    header: "Połącz PMS",
    loaderMessage: "Zapisywanie, proszę czekać.",
    selectPmsLabel: "Wybierz system PMS",
    selectPmsPlaceholder: "Wybierz PMS",
    apiKeyLabel: "Klucz API {pms}",
    apiKeyPlaceholder: "Wprowadź swój klucz API",
    cancel: "Anuluj",
    save: "Zapisz połączenie",
    fieldRequired: "Pole wymagane",
    selectPmsError: "Wybierz PMS",
    apiKeyError: "Wprowadź klucz API",
    savedTitle: "Połączenie zapisane",
    savedMessage: "Połączenie zostało zapisane pomyślnie",
    saveFailMessage: "Nie udało się zapisać połączenia",
    errorTitle: "Błąd",
    serverError: "Błąd połączenia z serwerem",
  },
  subscription: {
    title: "Moja subskrypcja",
    subtitle: "Przeglądaj swój plan, metodę płatności i rozliczenia oraz nimi zarządzaj.",
    statusActive: "Aktywna",
    // Cancelada pero todavía dentro de lo que ya pagó: ni «Activa» ni «Cancelada» a secas.
    statusCanceledValid: "Anulowana · aktywna do",
    validUntil: "Aktywna do:",
    statusPaymentPending: "Oczekuje na płatność",
    statusTrial: "Okres próbny",
    statusNone: "Brak aktywnej subskrypcji",
    intervalYearly: "Plan roczny",
    intervalMonthly: "Plan miesięczny",
    perMonthShort: "/mies.",
    nextRenewal: "Następne odnowienie:",
    servicesIncluded: "Usługi w pakiecie",
    units: "jednostka | jednostki | jednostek",
    perUnitSuffix: "/jednostka",
    serviceFallback: "Usługa",
    manageOpening: "Otwieranie…",
    manageButton: "Zarządzaj subskrypcją i fakturami",
    emptyText:
      "Nie masz jeszcze aktywnego planu. Wybierz jeden, aby zacząć przyjmować check-in i płatności.",
    buyPlan: "Kup plan",
    types: {
      apartment: "Apartament",
      hotel: "Hotel",
      room: "Pokój",
      camping: "Kemping",
      villa: "Willa",
      chatbot: "Recepcja AI",
    },
  },
  purchased: {
    title: "Dostępne w Twojej subskrypcji",
    subtitle: "Wykupiony limit i bieżące zużycie",
    accommodations: "Obiekty",
    empty: "Nie utworzono jeszcze żadnego obiektu.",
    createProperty: "Utwórz obiekt",
    adjust: "Dostosuj",
    loadError: "Nie udało się wczytać informacji.",
    labels: {
      apartment: "Apartament(y)",
      hotel: "Hotel (pokoje)",
      hotelPack: "Hotel (pokoje) · #{id}",
      villa: "Wille",
      camping: "Kempingi",
      campingPack: "Kempingi · #{id}",
      chatbot: "Licencje chatbota",
    },
    units: {
      unid: "jednostki",
      room: "pokoje",
      spots: "miejsca",
      licenses: "licencje",
    },
    types: {
      hotel: "Hotel",
      camping: "Kemping",
      villa: "Willa",
      apartment: "Apartament",
    },
    badge: {
      rooms: "{n} pokoi",
      spots: "{n} miejsc",
      unit: "1 jednostka",
    },
  },
  notifications: {
    title: "Powiadomienia",
    description: "Włączaj i wyłączaj automatyzacje wiadomości oraz alerty.",
    loading: "Wczytywanie ustawień...",
    alwaysActive: "Zawsze włączone",
    active: "Wł.",
    inactive: "Wył.",
    hint:
      "Uwaga: niektóre automatyzacje mają charakter informacyjny, ponieważ są już częścią standardowego procesu w systemie.",
    loadError: "Nie udało się wczytać ustawień.",
    saveError: "Nie udało się zapisać zmiany. Ponawianie...",
    items: {
      whatsapp_booking_confirmation: {
        title: "Potwierdzenie rezerwacji (WhatsApp)",
        description:
          "Automatycznie wysyła szablon potwierdzenia, gdy rezerwacja zostaje potwierdzona.",
      },
      email_checkin_sent: {
        title: "Powiadomienia e-mail przy wysłaniu check-in",
        description:
          "Wysyła automatyczną wiadomość e-mail, gdy proces check-in zostanie ukończony lub wysłany.",
      },
      whatsapp_checkin_link_auto: {
        title: "Automatyczna wysyłka WhatsApp z check-in online",
        description:
          "Automatycznie wysyła przez WhatsApp link do check-in online, gdy ma to zastosowanie.",
      },
      checkin_link_send_policy: {
        title: "Zasady wysyłki linku do check-in w rezerwacjach bezpośrednich",
        description:
          "Określ, czy link ma być wysyłany zawsze, czy tylko wtedy, gdy rezerwacja jest opłacona lub częściowo opłacona.",
        options: {
          always: {
            label: "Wysyłaj zawsze",
            description:
              "Wysyła link do check-in niezależnie od statusu płatności.",
          },
          paid_or_partially_paid: {
            label: "Tylko opłacone lub częściowo opłacone",
            description:
              "Wysyła link tylko wtedy, gdy rezerwacja jest w całości lub częściowo opłacona. Dotyczy wyłącznie rezerwacji bezpośrednich.",
          },
        },
      },
    },
  },
  wompi: {
    country: "Kolumbia",
    statusVerified: "Połączone",
    statusPending: "Niezweryfikowane",
    publicKeyLabel: "Klucz publiczny",
    privateKeyLabel: "Klucz prywatny",
    keepPrivateLabel: "Zachowaj zapisany klucz prywatny (ukryty ze względów bezpieczeństwa)",
    privatePlaceholderSaved: "•••••••••••• (zapisany)",
    btnDisconnect: "Odłącz",
    btnVerify: "Zweryfikuj konto",
    btnSave: "Zapisz dane dostępowe",
    merchantHeader: "Wykryto sprzedawcę",
    missingPublicKey: "Brakuje klucza publicznego",
    missingPrivateKey: "Brakuje klucza prywatnego",
    savedOk: "Dane dostępowe zapisane pomyślnie",
    saveError: "Błąd zapisu danych dostępowych",
    verifiedOk: "Konto zweryfikowane",
    notVerified: "Konto niezweryfikowane",
    verifyError: "Błąd weryfikacji konta",
    disconnectConfirm: "Czy na pewno chcesz odłączyć Wompi od tej firmy?",
    disconnectedOk: "Odłączono pomyślnie",
    disconnectError: "Błąd odłączania",
  },
  pricelabs: {
    subtitle: "Optymalizacja cen dynamicznych",
    statusConnected: "Połączone",
    statusDisconnected: "Niepołączone",
    loading: "Wczytywanie ustawień...",
    emailLabel: "E-mail PriceLabs",
    emailPlaceholder: "twoj-email@pricelabs.com",
    importantTitle: "Ważne:",
    bullet1: "Upewnij się, że Twoje obiekty są w pełni skonfigurowane",
    bullet2: "Nowe obiekty będą synchronizować się automatycznie",
    bullet3:
      "Ceny będą aktualizowane zgodnie z PriceLabs i nie będzie można ich edytować ręcznie w Wacheckin",
    btnConnect: "Połącz i zsynchronizuj",
    btnConnecting: "Łączenie...",
    btnSync: "Synchronizuj",
    btnSyncing: "Synchronizowanie...",
    btnDisconnect: "Odłącz",
    btnDisconnecting: "Odłączanie...",
    emailRequired: "Podaj swój e-mail PriceLabs",
    emailRequiredTitle: "E-mail wymagany",
    connectHeader: "Połączyć z PriceLabs?",
    connectMessage:
      "Wszystkie Twoje aktywne obiekty i pokoje zostaną powiązane. Taryfy i dostępność będą synchronizowane. Każdy obiekt lub pokój utworzony później zostanie wysłany automatycznie.",
    connectAccept: "Tak, połącz",
    cancel: "Anuluj",
    linkError: "Błąd powiązywania jednostek",
    emailNotFoundConnect:
      "PriceLabs zgłosił, że ten adres e-mail nie istnieje. Sprawdź adres i spróbuj ponownie.",
    emailInvalidTitle: "Nieprawidłowy e-mail PriceLabs",
    syncSuccess: "Twoje obiekty są teraz połączone z PriceLabs.",
    syncSuccessTitle: "Synchronizacja zakończona!",
    syncFail: "Nie udało się ukończyć synchronizacji",
    errorTitle: "Błąd",
    emailNotFoundManual:
      "PriceLabs wskazał, że ten adres e-mail nie istnieje. Popraw adres i zsynchronizuj ponownie.",
    manualSuccess: "Proces zakończył się pomyślnie.",
    manualSuccessTitle: "Synchronizacja ręczna",
    manualFail: "Nie udało się zsynchronizować z PriceLabs",
    disconnectHeader: "Odłączyć PriceLabs?",
    disconnectMessage: "Wszystkie Twoje obiekty zostaną odłączone od PriceLabs.",
    disconnectAccept: "Tak, odłącz",
    disconnectedOk: "Twoje konto zostało odłączone od PriceLabs",
    disconnectedTitle: "Odłączono",
    disconnectFail: "Nie udało się odłączyć od PriceLabs",
    noErrorsReported: "Nie zgłoszono błędów.",
    listingPrefix: "Oferta {id}: ",
    unknownError: "Nieznany błąd",
    listTitle: "Które ogłoszenia trafiają do PriceLabs",
    listHint: "Wybierz, którymi ma zarządzać PriceLabs. Wyłączone zachowują swoje ceny i edytujesz je sam.",
    listCount: "{n} z {total} wybranych",
    listSearch: "Szukaj obiektu lub pokoju…",
    listRooms: "{n} pokoi",
    listApartment: "Apartament",
    listEmpty: "Nie masz jeszcze obiektów.",
    listNoMatch: "Brak obiektu o tej nazwie.",
    listNeedsCurrency: "Brakuje waluty",
    listNeedsRate: "Brakuje planu cenowego",
    btnConnectN: "Połącz i synchronizuj | Połącz i synchronizuj {n} | Połącz i synchronizuj {n}",
    unitConnected: "{name} trafia teraz do PriceLabs",
    unitDisconnected: "{name} już nie trafia do PriceLabs",
    unitFail: "Nie udało się zmienić. Spróbuj ponownie.",
    listLocked: "Podłącz konto PriceLabs, a tutaj wybierzesz, którymi ogłoszeniami zarządza.",
    listAll: "Wszystkie",
    listNone: "Żadne",
    btnSyncN: "Synchronizuj | Synchronizuj 1 ogłoszenie | Synchronizuj {n} ogłoszeń",
    connectedOk: "Konto podłączone. Teraz wybierz, które ogłoszenia trafiają do PriceLabs.",
    connectedTitle: "Gotowe",
  },
};
